import { JSX, ReactNode } from 'react';

import { MarginProps } from 'app/components/v2/components/Box';
import { TooltipIconProps } from 'app/components/v2/components/TooltipIcon';

import { BannerSecondaryElementProps } from './BannerSecondaryElement';
import NotificationPresenter, { Severity } from './presenter';

interface ChildrenProps {
  children: ReactNode;
  message?: never;
}
interface MessageProps {
  children?: never;
  message: string;
}
type ChildrenOrMessageProps = ChildrenProps | MessageProps;
export type NotificationProps = ChildrenOrMessageProps & MarginProps & {
  id?: string;
  onClose?: () => void;
  secondaryElement?: BannerSecondaryElementProps;
  severity?: Severity;
  title?: string;
  tooltipProps?: TooltipIconProps['tooltipProps'];
  variant?: 'banner' | 'inline' | 'toast';
};

const Notification = ({
  id,
  onClose,
  secondaryElement,
  severity,
  title,
  tooltipProps,
  variant = 'inline',
  ...rest
}: NotificationProps): JSX.Element => {
  return (
    <NotificationPresenter
      {...rest}
      id={id}
      isStacked={variant === 'toast'}
      maxWidth={variant === 'toast' ? 356 : undefined}
      onClose={onClose}
      onlyBorderBottom={variant === 'banner'}
      rounded={variant !== 'banner'}
      secondaryElement={secondaryElement}
      severity={severity}
      title={title}
      tooltipProps={tooltipProps}
      withBoxShadow={variant === 'toast'}
    />
  );
};

export default Notification;
